import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { removeBaseEndpoint } from "@/helpers/Helpers";
import ChatItemHrefButtons from "./ChatItemHrefButtons";
interface LinkHandlerFrameProps {
  readonly href: string;
  readonly children: ReactNode;
  readonly hideLink?: boolean | undefined;
  readonly relativeHref?: string | undefined;
}
export default function LinkHandlerFrame(t0) {
  const $ = _c(12);
  const {
    href,
    children,
    hideLink: t1,
    relativeHref
  } = t0;
  const hideLink = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== href || $[1] !== relativeHref) {
    t2 = relativeHref ?? (() => {
      const relative = removeBaseEndpoint(href);
      return relative?.startsWith("/") ? relative : undefined;
    })();
    $[0] = href;
    $[1] = relativeHref;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const effectiveRelativeHref = t2;
  let t3;
  if ($[3] !== children) {
    t3 = <div className="tw-flex-1 tw-min-w-0 tw-max-w-full tw-overflow-hidden focus-within:tw-overflow-visible">{children}</div>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== effectiveRelativeHref || $[6] !== hideLink || $[7] !== href) {
    t4 = <ChatItemHrefButtons href={href} hideLink={hideLink} relativeHref={effectiveRelativeHref} />;
    $[5] = effectiveRelativeHref;
    $[6] = hideLink;
    $[7] = href;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="tw-flex tw-items-stretch tw-w-full tw-min-w-0 tw-max-w-full tw-gap-x-1">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}